"use client";

import { createBrowserClient } from "@supabase/ssr";
import { useMemo } from "react";
import type { Database } from "@/database.types";
import { env } from "@/lib/env";

export function useSupabaseClient() {
  return useMemo(() => {
    return createBrowserClient<Database>(env.nextPublicSupabaseUrl, env.nextPublicSupabaseAnonKey);
  }, []);
}
